import { PaletteMode, PaletteOptions, alpha } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unityDarkTokens, unityLightTokens } from '../unityTokens';
import { blue, grey, white, unityGrey } from './colors';

export const background = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['background'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          navigation: unityGrey[950],
          overlay: alpha(unityLightTokens['--bg-color-surface-backdrop'], 0.15),
          default: white,
          paper: unityGrey[50],
          tooltip: unityLightTokens['--bg-color-surface-floating'],
          popover: unityLightTokens['--bg-color-surface-floating'],
          canvas: unityLightTokens['--bg-color-surface-base'],
          container: unityLightTokens['--bg-color-surface-page-container'],
          hover: unityLightTokens['--bg-color-hover'],
          selected: unityLightTokens['--bg-color-surface-selected'],
        }
      : {
          navigation: unityGrey[900],
          overlay: alpha(unityDarkTokens['--bg-color-surface-backdrop'], 0.7),
          default: unityGrey[900],
          paper: unityGrey[800],
          tooltip: unityDarkTokens['--bg-color-surface-floating'],
          popover: unityDarkTokens['--bg-color-surface-floating'],
          canvas: unityDarkTokens['--bg-color-surface-base'],
          container: unityDarkTokens['--bg-color-surface-page-container'],
          hover: unityDarkTokens['--bg-color-hover'],
          selected: unityDarkTokens['--bg-color-surface-selected'],
        };
  }

  return mode === 'light'
    ? {
        navigation: grey[850],
        overlay: alpha(grey[950], 0.7),
        default: white,
        paper: grey[50],
        tooltip: grey[900],
        popover: white,
        canvas: grey[50],
        container: white,
        hover: grey[50],
        selected: blue[50],
      }
    : {
        navigation: grey[850],
        overlay: alpha(grey[850], 0.7),
        default: grey[900],
        paper: grey[850],
        tooltip: grey[850],
        popover: grey[850],
        canvas: grey[950],
        container: grey[900],
        hover: grey[800],
        selected: blue[850],
      };
};
